import React from 'react'
import blogData from './Blog.json';
import './Blog.css'

const BlogSection = () => {
  return (
       <div className='backdiv'>
      <h2 className='main_heading'>THE BLOG</h2>
      <div className='blog_grid'> 
 {blogData.map((blog) => (
          <div className='blog_card' key={blog.id}>
            <div className='blog_img_div'>
            <img src={blog.image} alt={blog.title}  className='zweedo_img' />
            </div>
            <div className='blog_content_div'>
            <h3 className='blog_title'>{blog.title}</h3>
            <p className='blog_date'>{blog.date}</p>
            <p className='blog_desc'> {blog.description.length > 180
                  ? blog.description.slice(0, 180) + '...' 
                  : blog.description}</p>
                  <a href={blog.link}>
            <button className='blog_btn'>Read More</button></a>
            </div>
          </div>
        ))}
      </div>

    </div>
  )
}

export default BlogSection